// Hand-maintained overrides for FORM_LOCALES.
//
// The base FORM_LOCALES (in ./locales.ts) is auto-generated from the Firestore
// dump and must not be edited directly — `node scripts/build-static-config.mjs`
// will overwrite it. Whenever a translation needs to be corrected (typo,
// industry term, agreement), add the fix here. The overrides are merged
// per-language at module load (see ./index.ts) and take precedence over the
// dump.
//
// Each entry's key matches the key in FORM_LOCALES[lang][key] (no `$` prefix).
// Refer to the original Spanish wording or the English source as the canonical
// reference for fishing-industry terminology.
//
// Origin of fixes:
//   - Audit run April 2026 (see /tmp/translation-audit.json — high+medium severity).
//   - Auto-translate bug report (cambio de texto.pdf) — fixed via meta tag in
//     public/index.html, this file just preserves the canonical Spanish
//     terminology so labels are correct on every platform.

export const LOCALE_OVERRIDES: Record<string, Record<string, string>> = {
	es: {
		// Spanish source had English typo "Saltwatter" instead of the Spanish word.
		form_trawl_gates_water_salt: "Salada",
	},
	en: {
		// "Sweetwater" is not the fishing-industry term for non-salt water.
		form_trawl_gates_water_sweet: "Freshwater",
	},
	fr: {
		// === Trawl systems (demersales / crustacean / pair / tangones / etc.) ===
		form_trawl_systems_speed: "Vitesse (kts)",
		form_trawl_systems_net_long: "Longueur du chalut (sans la poche) (m)",
		form_trawl_systems_bridle_length: "Longueur des bridons (m)",
		form_trawl_systems_headrope_length: "Longueur de la corde de dos (m)",
		form_trawl_systems_sweepline: "Longueur des bras (m)",
		form_trawl_systems_backstrop_length: "Longueur des entremises (m)",

		// === Flotation ===
		form_flotation_headrope_length: "Longueur de la corde de dos (m)",

		// === Pair trawl ===
		// "Câble traînant" is a literal translation; trawler crews say "fune".
		form_trawl_systems_pair_cable: "Fune + Bras (m)",

		// === Trawl gates (system selector) ===
		form_trawl_gates_system_twin: "Chalut jumeau",
	},
	it: {
		// === Trawl systems ===
		// "lima da suro" is a recurring typo of "lima da sughero" (cork rope).
		form_trawl_systems_headrope_length: "Lunghezza della lima da sughero (m)",
		form_trawl_systems_headrope_aperture: "Apertura della lima da sughero:",
		form_trawl_systems_bridle_length: "Lunghezza delle briglie (m)",
		form_trawl_systems_sweepline: "Lunghezza delle calate (m)",

		// === Flotation ===
		form_flotation_headrope_length: "Lunghezza della lima da sughero (m)",

		// === Propulsion (was wrongly using "Potenza Totale (CV)") ===
		form_propulsion_main_power: "Potenza principale (HP)",
		// Was "Velocità in pesca" — align with "Velocità di traino" used elsewhere.
		form_propulsion_trawl_speed: "Velocità di traino (Kts)",

		// === Tow cable (uses inconsistent "Potenza nominale") ===
		form_tow_cable_main_power: "Potenza principale (HP)",

		// === Pair trawl ===
		form_trawl_systems_pair_cable: "Cavo di traino + Calata (m)",

		// === Trawl gates (system selector) ===
		// "Tradizionale" diverges from the Spanish "Simple". The fishing
		// industry term in Italian for a one-net rig is "semplice".
		form_trawl_gates_system_simple: "Semplice",
	},
	pt: {
		// === Trawl systems ===
		form_trawl_systems_backstrop_length: "Comprimento dos pés de galo (m)",
		form_trawl_systems_net_long: "Comprimento da rede (sem o saco) (m)",
		form_trawl_systems_headrope_aperture: "Abertura da tralha superior:",
		form_trawl_systems_headrope_length: "Comprimento da tralha superior (m)",
		form_trawl_systems_sweepline: "Comprimento das malhetas (m)",
		form_trawl_systems_bridle_length: "Comprimento dos cabos de boca (m)",

		// === Flotation ===
		form_flotation_fishing_system_demersal: "Demersal",
		form_flotation_headrope_length: "Comprimento da tralha superior (m)",

		// === Propulsion ===
		form_propulsion_main_power: "Potência principal (HP)",

		// === Pair trawl (typo "arrastro" → "arrasto") ===
		form_trawl_systems_pair_cable: "Cabo de arrasto + Malhetas (m)",

		// === Winches ===
		// "Diâmetro do Cabo Real" — "Real" doesn't belong here.
		form_winches_cable_diameter: "Diâmetro do cabo (mm)",

		// === Trawl gates (system selector) ===
		// "2 Redes" is misleading because that label is the "twin trawl" rig
		// (one cable, two nets). Use the unambiguous "Rede gémea".
		form_trawl_gates_system_twin: "Rede gémea",
	},
};
